import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	user-select: none;
	pointer-events: none;
`;

const StyledTextLabel = styled(Text)`
	font-size: 16px;
	font-weight: 400;
	color: #ffffff;
	opacity: 0.75;
`;

export { StyledContainer, StyledTextLabel };
